import { api } from '../../../services/api'

/**
 * Chargebee callback.
 *
 * @endpoint POST /api/saas/chargebee/callback
 * @scope saas
 * @see https://flecto.dev/api-4724206
 */
export async function callbackChargebee(
  options?: CallbackChargebeeOptions
): Promise<void> {
  const headers = options?.httpAuthorization
    ? { HTTP_AUTHORIZATION: String(options?.httpAuthorization ?? '') }
    : undefined

  await api.post('/api/saas/chargebee/callback', null, {
    headers,
  })
}

export type CallbackChargebeeOptions = {
  httpAuthorization: string
}
